import request from '@/api/request'
const BASE_URL = process.env.AI_BASE_API

/**
 **
 * @param {Object} query
 * @param {string} query.template
 * @param {string} query.content
 * @param {string} query.currencyCode
 */
export function getContentByGrammarChecker (payload) {
  return request({
    url: `${BASE_URL}/grammar-checker-v2`,
    method: 'post',
    data: payload
  })
}

/**
 **
 * @param {Object} query
 * @param {string} query.template
 * @param {string} query.content
 * @param {string} query.currencyCode
 */
export function getTranslation (payload) {
  return request({
    url: `${BASE_URL}/translate-v2`,
    method: 'post',
    data: payload
  })
}
